export default __webpack_public_path__ + "static/media/IMG_3845.jpeg.0b2f787d.jpg";